export const TOPIC_DATA_SEO: Record<
  string,
  {
    title: string;
    description: string;
    navigationTitle: string;
    pageTitle: string;
    trackingKey: string;
  }
> = {
  'besondere-bewerbung': {
    title: 'CAREER_HUB_SUBTOPIC_PAGE_BESONDERE_TITLE',
    description: 'CAREER_HUB_SUBTOPIC_PAGE_BESONDERE_DESCRIPTION',
    navigationTitle: 'Besondere Bewerbung',
    pageTitle: 'Besondere Bewerbung - Alle Artikel',
    trackingKey: 'special_application',
  },
  'bewerbungsarten-formate': {
    title: 'CAREER_HUB_SUBTOPIC_PAGE_BEWERBUNGSARTEN_TITLE',
    description: 'CAREER_HUB_SUBTOPIC_PAGE_BEWERBUNGSARTEN_DESCRIPTION',
    navigationTitle: 'Bewerbungsarten Formate',
    pageTitle: 'Bewerbungsarten & Formate - Alle Artikel',
    trackingKey: 'types_and_formats',
  },
  anschreiben: {
    title: 'CAREER_HUB_SUBTOPIC_PAGE_ANSCHREIBEN_TITLE',
    description: 'CAREER_HUB_SUBTOPIC_PAGE_ANSCHREIBEN_DESCRIPTION',
    navigationTitle: 'Anschreiben',
    pageTitle: 'Tipps zum Anschreiben',
    trackingKey: 'cover_letter_tips',
  },
  vorstellungsgespräch: {
    title: 'CAREER_HUB_SUBTOPIC_PAGE_VORSTELLUNGSGESPRACH_TITLE',
    description: 'CAREER_HUB_SUBTOPIC_PAGE_VORSTELLUNGSGESPRACH_DESCRIPTION',
    navigationTitle: 'Vorstellungsgespräch',
    pageTitle: 'Tipps zum Vorstellungsgespräch',
    trackingKey: 'interview_tips',
  },
  lebenslauf: {
    title: 'CAREER_HUB_SUBTOPIC_PAGE_LEBENSLAUF_TITLE',
    description: 'CAREER_HUB_SUBTOPIC_PAGE_LEBENSLAUF_DESCRIPTION',
    navigationTitle: 'Lebenslauf',
    pageTitle: 'Tipps zum Lebenslauf',
    trackingKey: 'cv_tips',
  },
};
